import URL from '@/assets/configurations/BASE_URL.js'
import axios from 'axios'
import axiosInstance from '@/utils/axios'
import Cookies from 'vue-cookies'

const state = () => {
  return {
    getCustomers: {
      url: '/customers',
      method: 'GET'
    },
    getCustomerById: {
      url: '/customers/{id}',
      method: 'GET'
    },
    createCustomer: {
      url: '/customers',
      method: 'POST'
    },
    updateCustomer: {
      url: '/customers/{id}',
      method: 'PUT'
    },
    deleteCustomer: {
      url: '/customers/{id}',
      method: 'DELETE'
    },
    exportCustomers: {
      url: '/customers/export-customers',
      method: 'POST'
    },
    importCustomerOrders: {
      url: '/customers/import-orders',
      method: 'POST'
    },
    getCustomerImportHistory: {
      url: '/customers/import-history',
      method: 'GET'
    },
    downloadCustomerImportReport: {
      url: '/customers/import-history/{id}/download',
      method: 'GET'
    },
    storeCareLog: {
      url: '/customers/care-log',
      method: 'POST'
    },
    bulkAssign: {
      url: '/customers/bulk-assign', method: 'POST'
    },
    updateReminder: {
      url: '/customers/reminders/{id}',
      method: 'PUT'
    },
    completeReminder: {
      url: '/customers/reminders/{id}/complete',
      method: 'PATCH'
    },
    cancelReminder: {
      url: '/customers/reminders/{id}',
      method: 'DELETE'
    },
    getCareStatuses: {
      url: '/customer-care-statuses', method: 'GET'
    },
    createCareStatus: {
      url: '/customer-care-statuses', method: 'POST'
    },
    updateCareStatus: {
      url: '/customer-care-statuses/{id}', method: 'PUT'
    },
    deleteCareStatus: {
      url: '/customer-care-statuses/{id}', method: 'DELETE'
    }
  }
}
const actions = {
  async getCustomers(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.getCustomers.url,
      method: apiState.getCustomers.method,
      params: {
        ...payload,
      },
    });
  },

  async getCustomerById(id) {
    const apiState = state();
    return await axios({
      url: apiState.getCustomerById.url.replace('{id}', id),
      method: apiState.getCustomerById.method,
      baseURL: URL.BASE_URL,
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization:
          Cookies.get('token') != (null || undefined)
            ? `Bearer ${Cookies.get('token')}`
            : '',
      },
    });
  },

  async createCustomer(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.createCustomer.url,
      method: apiState.createCustomer.method,
      data: payload,
    });
  },

  async updateCustomer(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.updateCustomer.url.replace('{id}', payload.id),
      method: apiState.updateCustomer.method,
      data: payload
    });
  },

  async deleteCustomer(id) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.deleteCustomer.url.replace('{id}', id),
      method: apiState.deleteCustomer.method,
    });
  },
  async exportCustomers(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.exportCustomers.url,
      method: apiState.exportCustomers.method,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      data: payload,
    });
  },

  async importCustomerOrders(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.importCustomerOrders.url,
      method: apiState.importCustomerOrders.method,
      data: payload,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  async getCustomerImportHistory() {
    const apiState = state();
    return await axiosInstance({
      url: apiState.getCustomerImportHistory.url,
      method: apiState.getCustomerImportHistory.method
    });
  },
  async downloadCustomerImportReport(id) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.downloadCustomerImportReport.url.replace('{id}', id),
      method: apiState.downloadCustomerImportReport.method,
      responseType: 'blob'
    });
  },

  async storeCareLog(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.storeCareLog.url,
      method: apiState.storeCareLog.method,
      data: payload,
    });
  },
  async bulkAssign(payload) {
    return await axiosInstance({ url: state().bulkAssign.url, method: 'POST', data: payload });
  },
  async updateReminder(payload) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.updateReminder.url.replace('{id}', payload.id),
      method: apiState.updateReminder.method,
      data: { reminder_date: payload.reminder_date, note: payload.note }
    });
  },
  async completeReminder(id) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.completeReminder.url.replace('{id}', id),
      method: apiState.completeReminder.method
    });
  },
  async cancelReminder(id) {
    const apiState = state();
    return await axiosInstance({
      url: apiState.cancelReminder.url.replace('{id}', id),
      method: apiState.cancelReminder.method
    });
  },
  async getCareStatuses(type = 'care', customerSegment = null) {
    return await axiosInstance({
      url: state().getCareStatuses.url,
      method: 'GET',
      params: { type, customer_segment: customerSegment || undefined }
    });
  },
  async createCareStatus(payload) {
    return await axiosInstance({ url: state().createCareStatus.url, method: 'POST', data: payload });
  },
  async updateCareStatus(payload) {
    return await axiosInstance({ url: state().updateCareStatus.url.replace('{id}', payload.id), method: 'PUT', data: payload });
  },
  async deleteCareStatus(id) {
    return await axiosInstance({ url: state().deleteCareStatus.url.replace('{id}', id), method: 'DELETE' });
  }
}
export default {
  state,
  actions
}
